import { TableRow } from './TableRow'
import { withTableRow } from './withTableRow'

const Connected = withTableRow(TableRow)

export { Connected as TableRow }
